import Devices from '../../../views/practice/meds-devices/devices/Devices'
import Medications from '../../../views/practice/meds-devices/medications/Medications'

const medsDevicesRoutes = [
  {
    path: '/practice/medications',
    element: <Medications />
  },
  {
    path: '/practice/devices',
    element: <Devices />
  },
]

export default medsDevicesRoutes
